import * as PIXI from "pixi.js";

export class HeartsFlow extends PIXI.Sprite {
	elasped = 0;
	angleOffset = 20;
	radiusX = 30;
	speedY = 1;
	limitY = 0;

	originPos = { x: 0, y: 0 };

	/** 
	 * {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			angleOffset: 20,
			radiusX: 30,
			speedY: 1,
			disY: 200,
		}
	 */
	constructor(tex, option) {
		super(tex);
		this.originPos = {
			x: option.x,
			y: option.y,
		};
		this.x = this.originPos.x;
		this.y = this.originPos.y;

		this.width = option.width;
		this.height = option.height;

		this.angleOffset = option.angleOffset;
		this.radiusX = option.radiusX;
		this.speedY = option.speedY;
		this.limitY = this.y - option.disY;
	}

	ticker(delta) {
		this.elasped += delta;
		this.x = this.originPos.x + Math.cos(this.elasped / this.angleOffset) * this.radiusX;
		this.y -= this.speedY;
		if (this.y <= this.limitY) {
			this.emit("dead", this);
			this.destroy();
		}
	}
}

export function randomInt(min, max) {
	return Math.round(Math.random() * (max - min)) + min;
}
export const randomNumberInRange = (min, max) => Math.random() * (max - min) + min;